import { SectionAccordion } from '@sbercloud/uikit-product-site-section';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';

import { AccordionProps } from './type';

export function Accordion({ id, title, cards }: AccordionProps) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();

  const expandedDefault = cards.reduce<string[]>((acc, card, index) => {
    if (card.initialOpen) {
      acc.push(String(index));
    }

    return acc;
  }, []);

  return (
    <SectionAccordion
      id={id}
      title={title}
      selectionMode="multiple"
      expandedDefault={expandedDefault}
      outline
      items={cards.map((card) => ({
        title: card.title,
        description: (card.mdxText || card.richText) as string,
        onClick: () => {
          clickAnalytics({
            action: 'click',
            clickZone: 'body',
            clickElement: 'cardclick',
            clickContent: `accordion-item-${card.title}`,
            uniqueId: `accordion-item-${card.title}`,
            transitionType: 'inside-link',
          });
        },
      }))}
      layoutType={layoutType}
    />
  );
}
